import { Box } from "@mui/system";
import { useSelector } from "react-redux";
import React from "react";
import AccountSummeryDateFilter from "./AccountSummeryContent/AccountSummeryDateFilter";
import AccountSummeryTabs from "./AccountSummeryContent/AccountSummeryTabs";
import AccountSummarySkel from "./helpers/AccountSummarySkel";

const AccountSummery = () => {
  const { loadingOverviewAccountSummaryData } = useSelector(
    (state: any) => state.bizDevelopmentDashboardMobile,
  );
  const [sortConfig, setSortConfig] = React.useState({
    field: "Date",
    direction: "desc",
  });
  const [refreshKey, setRefreshKey] = React.useState(0);

  const handleRefresh = () => setRefreshKey((prev) => prev + 1);

  return (
    <>
      <Box sx={{ px: 2 }}>
        <AccountSummeryDateFilter refreshKey={refreshKey} />
        {loadingOverviewAccountSummaryData ? (
          <AccountSummarySkel />
        ) : (
          <AccountSummeryTabs
            sortConfig={sortConfig}
            setSortConfig={setSortConfig}
            onRefresh={handleRefresh}
          />
        )}
      </Box>
    </>
  );
};

export default AccountSummery;
